import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const ForInvestorsPageRouter: CustomRouteObject = {
  path: routeNamesPaths.forInvestors,
  lazy: async () => {
    const { ForInvestorsPage } = await import('./ui')

    return {
      Component: ForInvestorsPage,
    }
  },
  nodeRef: createRef(),
}
